import React from 'react';
import { Fragment } from 'react';
import { WordShape, TackShape } from '../../shapes';
import PropTypes from 'prop-types';
import DateMaster from '../../stores/utils/date_master';
import BeingTackedBy from '../being_tacked_by';
import WordLanguage from './word_language';

export default class Word extends React.Component {

  static propTypes = {
    word: WordShape,
    targetLanguage: PropTypes.string,
    tack: TackShape
  }

  render() {
    const definitionList = this.props.word.get('definitions').map((definitionText, i) => { return(<li key={i}>{ definitionText }</li>) });
    const meta = (this.props.tack && this.props.tack.get('wordText')) ? this.renderUsersTackMeta() : this.renderGenericMeta();
    return(
      <Fragment>
        <div className='item-meta'>
          <div>
            { meta }
          </div>
          <div className='give-me-10-top'>
            Definition in: <WordLanguage wordText={ this.props.word.get('wordText') } targetLanguage={ this.props.targetLanguage }  />
          </div>
        </div>
        <ol className='definition-text'>{ definitionList }</ol>
        <p className='example-text'>
          { this.props.word.get('exampleText') }
        </p>
      </Fragment>
    );
  }

  renderGenericMeta() {
    return (
      <BeingTackedBy tackedBy={ this.props.word.get('tackedByWithMetaData') } tacksCount={ this.props.word.get('tacksCount') } />
    );
  }

  renderUsersTackMeta() {
    return (
      <Fragment>
        Started tacking { DateMaster.timeSince(this.props.tack.get('createdAt')) } ago &middot; <BeingTackedBy tackedBy={ this.props.word.get('tackedByWithMetaData') } tacksCount={ this.props.word.get('tacksCount') } />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/word/word_definition.jsx